import { User } from 'src/app/models/User';
import { Api } from '../base/Api';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root'
})
export class UserApi extends Api<User> {
}
